export default __webpack_public_path__ + "static/media/chequeDeposit.06fa1d21.svg";